<div class="card"
  style="margin-bottom: 0px; margin-top: 0px;font-family: Avenir,Avenir Next,Segoe UI,Helvetica,Arial,sans-serif;">
  <div class="card-header card-header-primary">
    <div class="row">
      <div class="col-sm-12 col-md-11">
        <h4 class="card-title"><b>Edición Solicitud Ticket</b></h4>
      </div>
      <div class="col-sm-12 col-md-1">
        <button mat-icon-button (click)="salir()" tabindex="0">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="wraper">
      <div class="container">

        <!--Inicia Form ---------------------------------------------------------->
        <form [formGroup]='options'>
          <div class="row">
            <div class="col-sm-6 border-right">
                  <!--Asunto-->
                      <div class="col-sm-12" >
        				 <mat-form-field>
         					 <input matInput placeholder="Asunto" aria-label="Asunto" formControlName='asuntoCtrl' [(ngModel)]="tickets.asunto" readonly>
       					 </mat-form-field>
                    </div>

                                <!--Fecha Solicitud-->
                  <div class="col-sm-6">
                    <mat-form-field>
                    <input matInput placeholder="Fecha Solicitud" aria-label="Fecha Solicitud" formControlName='fechaSolicitudCtrl' [(ngModel)]="tickets.fechaSolicitud" readonly>
                    </mat-form-field>
                    </div>
  

    
                    <!--justificacion-->
                    <div class="col-sm-12">
   							 <mat-form-field>
         								 <textarea matInput placeholder="Justificación Solicitante" aria-label="Justificación Solicitante" formControlName='justificacionCtrl'
           								 [(ngModel)]="tickets.justificacion" maxlength="512" readonly rows="6"></textarea>
        					</mat-form-field>
                    </div>
            </div>

            <!--Evidencias-->
            <div class="col-sm-6">
              <div class="row">

                <div class="col-sm-6">
  					<mat-form-field>
          					<mat-select required formControlName='TipoSolicitudCtrl' [(ngModel)]="tickets.tipoSolicitud"          (selectionChange)="orgValueChange()" >
          			  			<mat-option *ngFor="let items of tipoSolicitud" [value]="items.nombre">{{items.nombre}}</mat-option>
          					</mat-select>
          				<mat-label> <b> Tipo de Solicitud</b> </mat-label>
       				</mat-form-field>
        			<mat-error  *ngIf=' options.controls.TipoSolicitudCtrl.invalid && (options.controls.TipoSolicitudCtrl.dirty || options.controls.TipoSolicitudCtrl.touched) && options.controls.TipoSolicitudCtrl.errors.required'>
          				El campo es requerido.</mat-error>
                </div>

                <div class="col-sm-6">
                   <mat-form-field>
         			 	<mat-select required formControlName='prioridadCtrl' [(ngModel)]="tickets.prioridad">
           			 		<mat-option *ngFor="let items of prioridadesFiltradas" [value]="items.nombre">{{items.nombre}}</mat-option>
          				</mat-select>
          			<mat-label> <b> Prioridad</b> </mat-label>
        			</mat-form-field>
        			<mat-error  *ngIf=' options.controls.prioridadCtrl.invalid && (options.controls.prioridadCtrl.dirty || options.controls.prioridadCtrl.touched) && options.controls.prioridadCtrl.errors.required'>
          				El campo es requerido.</mat-error>
                </div>
                  <!--Área Solicitante-->
                  <div class="col-sm-6">
 								<mat-form-field>
           						 <input matInput placeholder="Área Solicitante" aria-label="Área Solicitante" formControlName='areaCtrl' [(ngModel)]="tickets.areaSolicitante" readonly>
       							 </mat-form-field>
                  </div>
                    <!--Área Resolutora-->
                  <div class="col-sm-6">
		       			 <mat-form-field>
            				<input matInput placeholder="Área Resolutora" aria-label="Área Resolutora" formControlName='areaResCtrl' [(ngModel)]="tickets.areaResolutora" readonly>
       					 </mat-form-field>
                   </div>

  <!--Empresa-->
                    <div class="col-sm-6" >
                      <mat-form-field>
                  <input matInput placeholder="Nombre Solicitante" aria-label="Nombre Solicitante" formControlName='nombreCtrl' [(ngModel)]="tickets.nombreSolicitante" readonly>
                  </mat-form-field>
                  </div>
                  <!--Empresa-->
                  <div class="col-sm-6" >
                  <mat-form-field>
                  <input matInput placeholder="Empresa Seleccionada" aria-label="Empresa Seleccionada" formControlName='empresaCtrl' [(ngModel)]="nombreEmpresa" readonly>
                  </mat-form-field>
                  </div>
      
                              <!--telefonoContacto-->
                              <div class="col-sm-6">
                                <mat-form-field>
                                  <input matInput placeholder="Teléfono de contacto" aria-label="Teléfono de contacto" formControlName='telefonoCtrl' [(ngModel)]="tickets.telefonoContacto"  type="tel"  readonly>
                              </mat-form-field>
                        </div>
              
      

              </div>

            
 
             
            </div>


          </div>
        </form>
          <div class="row" >
             <div class="col-sm-6 border-right ml-auto">
              <div mat-dialog-actions class="justify-content-end">
             
                <button mat-button class="btn btn-danger" (click)='salir()'  tabindex="0" >  <i class="fa fa-times-circle-o"></i> Cancelar </button>
        
                <button mat-button (click)='guardar()' class="btn  btn-success" [disabled]="!options.valid"  tabindex="0"   onClick="this.disabled=true">   Guardar <i class='material-icons'> save </i>                </button>
              </div>
          </div>
          </div>

   

        <!--Termina form ------------------------------------------------------------>
      </div>
    </div>
  </div>

</div>